module.exports = __webpack_public_path__ + "static/media/trainVideo2.d4353061.mp4";